import { SearchIcon } from "@heroicons/react/outline";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import PlaceHolder from "../../../../components/placeHolder.tsx/PlaceHolder";
import { useInfiniteQuery } from "react-query";
import KhetmaCard from "../../../../components/khetma-card";
import { indexStudents } from "../../../../api/endpoints/supervisors/students";
import StudentModel from "../../../../api/models/StudentModel";
import { FullSpinner } from "../../../../components/LoadingSpinner";

export default function KhetmaView() {
  const LocalBasePath = "page.supervisor.student";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [filters, setFilters] = useState<{ [key: string]: any }>({});
  const [currentPage, setCurrentPage] = useState(1);
  // const [isLoading, setIsLoading] = useState<boolean>(true);

  let [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const resetCurrentPage = () => {
    setCurrentPage(1);
  };

  const {
    data: studentsPages,
    fetchNextPage: fetchNextPageStudents,
    isLoading,
  } = useInfiniteQuery(
    ["studentsData", filters],
    ({ pageParam = 1 }) => {
      return indexStudents({
        filters,
        pagination: {
          pageSize: 25,
          pageNumber: pageParam,
        },
      });
    },
    {
      select: (data) => {
        let fetchedStudents: StudentModel[] = [];

        return {
          pages: data.pages
            .map((pageResponse) => {
              if (pageResponse.isSuccess) {
                fetchedStudents = StudentModel.fromApiResponse(
                  pageResponse.data
                );
              }
              return fetchedStudents;
            })
            .flat(),
          pageParams: data.pageParams,
        };
      },
      cacheTime: 0,
    }
  );

  useEffect(() => {
    const element = document.getElementById("scroll_container");

    const handleScroll = () => {
      if (!!element) {
        const { clientHeight, scrollTop, scrollHeight } = element;
        const bottom: boolean =
          Math.floor(scrollHeight - scrollTop) <= clientHeight;
        if (bottom) {
          setCurrentPageNumber((prev) => prev + 1);
        }
      }
    };
    if (!!element) element.addEventListener("scroll", handleScroll);

    return () => {
      if (!!element) element.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const students = useMemo(() => {
    if (studentsPages) {
      return studentsPages.pages.flat();
    }
    return [];
  }, [studentsPages]);

  useEffect(() => {
    fetchNextPageStudents({ pageParam: currentPageNumber });
  }, [currentPageNumber]);

  useEffect(() => {
    resetCurrentPage();
  }, [filters]);

  return (
    <div className="flex flex-col justify-between w-full min-h-screen mb-5 bg-gray-50 ">
      <div className="flex flex-col h-full min-w-full w-fit ">
        <div className="flex items-center justify-between p-4 text-gray-900 ">
          <h2 className="text-2xl">{t("khetma")}</h2>
        </div>
        <div className="relative mx-4 mt-1 rounded-md shadow-sm ">
          <div className="absolute inset-y-0 flex items-center pointer-events-none start-0 ps-3">
            <SearchIcon className="w-5 h-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            className="block w-full border-gray-300 rounded-md focus:ring-brandblue-500 focus:border-brandblue-500 ps-10 sm:text-sm"
            placeholder={t("search")}
            onChange={(e) => setFilters({ q: e.target.value })}
          />
        </div>
        {isLoading ? (
          <div className="w-full h-full">
            <FullSpinner size={64} />
          </div>
        ) : (
          <>
            {!!studentsPages && students.length > 0 ? (
              <div className="grid items-center justify-center w-full grid-cols-1 gap-6 px-6 mx-auto mt-6 bg-gray-50 ">
                {students.map((student) => (
                  <>
                    <KhetmaCard student={student} />
                  </>
                ))}
              </div>
            ) : (
              <div className="flex items-center justify-center w-full h-full">
                <PlaceHolder title="noReadersTitle" />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
